import { Lightning } from '@lightningjs/sdk';
import { getSvgTexture } from '@tornado-rdk/icons';
import { CODE_SIZE, defaultContext, getInitialStyle, STEPS_MARGIN_LEFT } from './mobilePairing.style';
import { displaySteps, getSteps, makeKeys, makePatch } from '../pairing.utils';
import { SELECTED_SIGNAL } from '../../signals';

// NOTE: qrcode is only reachable from the QR and pairing screens, so it is loaded on demand.
const loadQRCode = () =>
  import(
    /* webpackChunkName: "vendor.qrcode" */
    'qrcode'
  ).then(module => module.default);

export class MobilePairing extends Lightning.Component {
  static _template() {
    return getInitialStyle();
  }

  _construct() {
    this._style = defaultContext;
  }

  _inactive() {
    this.tag('Code').removeAllListeners('txLoaded');
    this._token = null;
  }

  set labels(value) {
    this.tag('Title').text.text = value.title;

    displaySteps(getSteps(this, 5), makeKeys(value.steps, value.stepsCount));
  }

  set button(value) {
    this.tag('Button').patch({
      label: value,
      visible: Boolean(value),
    });

    this._refocus();
  }

  get w() {
    return super.w;
  }

  set w(value) {
    super.w = value;
    const { screenSize } = this._style;
    const stepsWidth = value - CODE_SIZE[screenSize] - STEPS_MARGIN_LEFT[screenSize];

    // WARN: only static values are supported
    this.patch({
      Title: {
        text: {
          wordWrapWidth: value,
        },
      },
      Content: {
        CodeContainer: {
          w: value,
          Steps: {
            w: stepsWidth,
            ...makePatch(5, { w: stepsWidth }),
          },
        },
      },
    });
  }

  set url(value) {
    if (value === this._token) {
      return;
    }

    this._token = value;

    const code = this.tag('Code');
    code.alpha = 0.0001;

    if (!value) {
      return;
    }

    code.once('txLoaded', () => {
      code.setSmooth('alpha', 1);
    });

    // Using high-resolution QR codes triggers an issue on Magenta devices in FHD mode
    // possible solution: https://www.npmjs.com/package/qrcode-generator
    loadQRCode()
      .then(QRCode => QRCode.toDataURL(value, { margin: 4, width: CODE_SIZE.HD }))
      .then(dataUrl => {
        const texture = getSvgTexture(dataUrl, CODE_SIZE[this._style.screenSize], CODE_SIZE[this._style.screenSize]);
        code.texture = texture;
      });
  }

  _handleEnter() {
    if (!this.tag('Button').visible) {
      return false;
    }

    this.signal(SELECTED_SIGNAL);

    return true;
  }

  _getFocused() {
    const button = this.tag('Button');

    return button.visible ? button : undefined;
  }
}
